import { Plate, EPlateErrorStatus } from './Plate';
import { ELightPath } from './CaptureProfile';
export enum EImagingStatus {
  /// <summary>
  /// The imaging has not started.
  /// </summary>
  NotCompleted = 1,
  /// <summary>
  /// The imaging has been cancelled before starting.
  /// </summary>
  Skipped = 2,
  /// <summary>
  /// The imaging will commence as soon as possible.
  /// </summary>
  Pending = 3,
  /// <summary>
  /// The imaging has not started, but the imager
  /// has started preparations for the imaging.
  /// </summary>
  Queued = 4,
  /// <summary>
  /// The imager is imaging the plate.
  /// </summary>
  Imaging = 5,
  /// <summary>
  /// The imaging has been completed,
  /// successfully or unsuccessfully.
  /// </summary>
  Completed = 6,
  /// <summary>
  /// The imaging has been cancelled
  /// </summary>
  Cancelled = 7,
}

export enum EScheduleState {
  Unknown = 0,
  Queued = 1, //entry is created and queueing in schedule queue (eligible for imaging)
  Pending = 2, //entry is ready to be imaged;
  Imaging = 3, //entry is being imaged
  Paused = 4, //entry is paused and not eligible for imaging
  Cancelled = 5, //entry is cancelled and to be removed
  Completed = 6, //entry is completed and to be removed
  PlateMovementError = 7, //entry is cancelled due to error during plate movement to imager
  Skipped = 8, // entry is skipped because newer schedule exist
}

export interface ScheduleEntry {
  projectName: string;
  experimentName: string;
  plateNumber: number;
  username: string;
  plateTypeName: string;
  plateId: string;
  priority: number;
  dateToImage: string;
  id: string;
  scheduleState: EScheduleState;
  barcode:string;
  lightPaths: ELightPath[];
  plateErrorStatus:EPlateErrorStatus;
}

export interface ImagingSchedule {
  dateToImage: string;
  priority: number;
  state: EImagingStatus;
  dateImaged: string;
  inQueue: boolean;
  plate: Plate;
}
